import { attachments } from '@wix/inbox-common';
export function isFileTooLarge(file) {
    return file.size > 1024 * 1024 * 15;
}
export function getFileSecureUrl(url) {
    return url.replace('http://', 'https://');
}
export var allAttachmentTypes = [
    attachments.attachmentTypes.IMAGE,
    attachments.attachmentTypes.DOC,
    attachments.attachmentTypes.PPT,
    attachments.attachmentTypes.XLS,
    attachments.attachmentTypes.PDF,
];
export function toDialogFileType(attachmentType) {
    switch (attachmentType) {
        case attachments.attachmentTypes.IMAGE:
            return 'image/*';
        case attachments.attachmentTypes.XLS:
            return '.xlsx,.xls';
        case attachments.attachmentTypes.DOC:
            return '.doc,.docx';
        case attachments.attachmentTypes.PPT:
            return '.ppt,.pptx';
        case attachments.attachmentTypes.PDF:
            return '.pdf';
        default:
            return '';
    }
}
export function toDialogFileTypes(attachmentTypes) {
    return attachmentTypes.map(function (type) { return toDialogFileType(type); }).join(',');
}
export function isFileTypeSupported(file, attachmentTypes) {
    return attachmentTypes.indexOf(attachments.getAttachmentType(file.type)) > -1;
}
//# sourceMappingURL=media-utils.js.map